import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { isVpaaS } from '../services/auth0';

import VideoLogoIcon from './icons/eght-video';
import JaasLogoIcon from '~/components/icons/jaas';
import AuthProvidersPane from './auth-providers-pane';
import { TABLET_THRESHOLD, MOBILE_THRESHOLD, MOBILE_SMALL_THRESHOLD } from '../core/constants';
import Footer from './footer';
import { translate } from '~/services/translate';
import ResetPassword from './reset_password';
import { ColumnFlex } from '~/components/basic/containers';
import Title from './basic/title';

const AuthPaneContainer = styled(ColumnFlex)`
  position: relative;
  margin: auto auto auto 20px;
  background: #FFF;
  width: 340px;
  max-width: 340px;
  min-height: 549px;
  padding: 40px 64px 0;
  border-radius: 8px;

  @media screen and (max-width: ${TABLET_THRESHOLD}px) {
    margin: auto;
  }

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    width: 100%;
    border-radius: 0;
    padding: 23px 0;
    margin-top: 0;
  }

  @media screen and (max-width: ${MOBILE_SMALL_THRESHOLD}px) {
    width: 100%;
    margin-top: 0;
    border-radius: 0;
    padding: 23px 24px 0;
  }
`;

const AuthPane = ({ isSignUp, onSwitchMode }) => {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const switchToResetPassword = () => {
    setShowResetPassword(true);
  }

  const switchToMainView = () => {
    setShowResetPassword(false);
  }

  const onModeSwitch = () => {
    if (!isSignUp) {
      setShowResetPassword(false);
    }
    onSwitchMode();
  }

  return (
    <AuthPaneContainer>
      <Title
        LogoIcon={isVpaaS() ? JaasLogoIcon : VideoLogoIcon}
        title={isVpaaS() ? translate('eght_meet_api') : translate('sign_up_title')}
      />
      {showResetPassword ?
        <ResetPassword switchToMainView={switchToMainView} /> :
        <AuthProvidersPane isSignUp={isSignUp} switchToResetPassword={switchToResetPassword} />
      }
      {isVpaaS() && <Footer isSignUp={isSignUp} onSwitchMode={onModeSwitch} />}
    </AuthPaneContainer>
  );
}

AuthPane.propTypes = {
  isSignUp: PropTypes.bool,
  onSwitchMode: PropTypes.func,
}

export default AuthPane; 